import { Zap } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { scrollToId } from "@/lib/scroll";

export const Header = () => {
  const { lang, setLang, t } = useLang();

  const navItems = [
    { id: "como-funciona", label: t.nav.how },
    { id: "que-incluye", label: t.nav.features },
    { id: "precios", label: t.nav.pricing },
    { id: "preguntas", label: t.nav.faq },
  ];

  return (
    <header className="fixed top-0 inset-x-0 z-50 border-b lp-hairline bg-[#09090b]/75 backdrop-blur-xl">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 h-16 flex items-center justify-between gap-3">
        <a
          href="/"
          data-testid="header-logo"
          className="flex items-center gap-2 font-black tracking-tighter text-lg"
        >
          <span className="grid place-items-center w-8 h-8 rounded-lg bg-[#f5a623] text-[#09090b]">
            <Zap size={18} strokeWidth={2.5} fill="currentColor" />
          </span>
          <span>
            Lightning <span className="text-[#f5a623]">POS</span>
          </span>
        </a>

        <nav className="hidden lg:flex items-center gap-7" aria-label="principal">
          {navItems.map((n) => (
            <button
              key={n.id}
              data-testid={`nav-${n.id}`}
              onClick={() => scrollToId(n.id)}
              className="text-sm text-[#a1a1aa] hover:text-white transition-colors"
            >
              {n.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <div
            className="flex items-center rounded-full border lp-hairline p-0.5 text-xs font-semibold"
            role="group"
            aria-label="Idioma / Language"
          >
            <button
              data-testid="lang-toggle-es"
              onClick={() => setLang("es")}
              aria-pressed={lang === "es"}
              className={`px-2.5 py-1 rounded-full transition-colors ${
                lang === "es" ? "bg-[#f5a623] text-[#09090b]" : "text-[#a1a1aa] hover:text-white"
              }`}
            >
              ES
            </button>
            <button
              data-testid="lang-toggle-en"
              onClick={() => setLang("en")}
              aria-pressed={lang === "en"}
              className={`px-2.5 py-1 rounded-full transition-colors ${
                lang === "en" ? "bg-[#f5a623] text-[#09090b]" : "text-[#a1a1aa] hover:text-white"
              }`}
            >
              EN
            </button>
          </div>
          <button
            data-testid="header-cta-button"
            onClick={() => scrollToId("lista-espera")}
            className="hidden sm:inline-flex items-center rounded-full bg-[#f5a623] text-[#09090b] text-sm font-bold px-4 py-2 hover:bg-[#ffbb3d] transition-colors"
          >
            {t.nav.cta}
          </button>
        </div>
      </div>
    </header>
  );
};
